import {useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'

import {SearchResult} from './SearchResult'
import {Products} from '../utils/Product'

import Tipoblack from '../assets/img/Tipo black.svg'
import Menu from '../assets/img/menu_header.svg'
import menuHeaderHover from '../assets/img/menu_header_hover.svg'
import logotwo from '..//assets/img/logo_secondary.svg'
import tipo from '../assets/img/Tipo.svg'
import movio from '../assets/img/movio.svg'
import comment from '../assets/img/comment.svg'
import threeDots from '../assets/img/three_dots.svg'
import Avatar from '../assets/img/Avatar.svg'

export const Navbar = ({no_need_search: noNeedSearch = null}) => {
	const [SearchingProducts, setSearchProducts] = useState(Products)
	const [SearchInput, setSearchInput] = useState('')
	const [ShowSearch, setShowSearch] = useState(false)
	const [dropdownExe, setdropdownExe] = useState(false)
	const navigate = useNavigate()

	return (
		<div className='Navbar'>
			<div className='menu_area'>
				<img src={Menu} alt='' className='menu_area_logo' />
				<img src={menuHeaderHover} alt='' className='menu_area_logo' />
				<nav>
					<li>
						<Link to='/'>
							<svg
								width='15'
								height='15'
								viewBox='0 0 15 15'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<mask
									id='mask0_2447_6193'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='15'
									height='15'
								>
									<rect width='15' height='15' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_2447_6193)'>
									<path
										d='M9.52677 12.9951C9.5268 12.9951 9.52683 12.995 9.52685 12.995L9.54389 13.042C8.88866 13.2795 8.19733 13.4019 7.5004 13.4039C7.11664 13.4063 7.11583 14.002 7.5004 14C10.1985 13.985 12.6428 12.2908 13.5939 9.76372L9.52677 12.9951ZM9.52677 12.9951C11.8144 12.1618 13.341 9.92065 13.3543 7.49993V7.49989C13.3549 7.38971 13.3987 7.30382 13.4662 7.24617C13.5326 7.1894 13.6192 7.16221 13.7038 7.16224C13.7885 7.16227 13.8749 7.18951 13.9408 7.24645C14.0077 7.30428 14.0505 7.39029 14.05 7.50034M9.52677 12.9951C8.87699 13.2305 8.1914 13.3519 7.50026 13.3539L7.50009 13.3539C7.38998 13.3546 7.3041 13.3984 7.24643 13.4658C7.18962 13.5322 7.16234 13.6189 7.16228 13.7036C7.16222 13.7883 7.18939 13.8748 7.24635 13.9407C7.30422 14.0078 7.39038 14.0506 7.50067 14.05C10.2194 14.0349 12.6823 12.3279 13.6407 9.78133L13.6408 9.78109C13.9112 9.05107 14.0497 8.27882 14.05 7.50034M14.05 7.50034C14.05 7.50038 14.05 7.50043 14.05 7.50047L14 7.5002L14.05 7.50022C14.05 7.50026 14.05 7.5003 14.05 7.50034ZM1.64615 7.50052L1.64615 7.50047C1.65904 5.0814 3.18601 2.8382 5.47355 2.00497C6.12349 1.76945 6.80925 1.64806 7.50054 1.64614L7.50072 1.64614C7.61075 1.64544 7.69655 1.6016 7.75417 1.53416C7.81091 1.46774 7.83817 1.38112 7.83823 1.29643C7.83828 1.21175 7.81115 1.12527 7.75425 1.05929C7.69643 0.992263 7.61035 0.949423 7.50014 0.950006L7.50013 0.950006C4.78098 0.965146 2.31812 2.67213 1.3593 5.21866L1.35921 5.21891C1.08876 5.9491 0.950206 6.72153 0.95 7.50019V7.5002C0.95 7.61018 0.993137 7.69606 1.06018 7.75378C1.1262 7.81061 1.21256 7.83783 1.29714 7.83786C1.38173 7.83789 1.4682 7.81073 1.53449 7.75399C1.60179 7.69638 1.64545 7.61057 1.64615 7.50052ZM5.31149 9.99884V10.0488H5.36149H8.02671C8.67495 10.0488 9.20915 9.9016 9.58273 9.63219C9.95791 9.36162 10.1681 8.96965 10.1681 8.49064C10.1681 7.81908 9.78657 7.29379 9.17487 7.10707C9.67619 6.9028 9.98252 6.45987 9.98252 5.91769C9.98252 5.48354 9.77834 5.12853 9.4187 4.88397C9.06073 4.64056 8.55048 4.50731 7.93493 4.50731H5.36149H5.31149V4.55731V9.99884ZM11.0205 5.83815C11.3773 5.83815 11.6666 5.54887 11.6666 5.19202C11.6666 4.83517 11.3773 4.54589 11.0205 4.54589C10.6636 4.54589 10.3743 4.83517 10.3743 5.19202C10.3743 5.54887 10.6636 5.83815 11.0205 5.83815ZM7.85696 6.68351H6.78775V5.66313H7.85696C8.05156 5.66313 8.20423 5.71143 8.30728 5.79599C8.40903 5.87949 8.46768 6.00258 8.46768 6.165C8.46768 6.3277 8.40919 6.45534 8.30704 6.54304C8.20399 6.6315 8.0515 6.68351 7.85696 6.68351ZM7.85696 8.88368H6.78775V7.77883H7.85696C8.10712 7.77883 8.30385 7.83386 8.43657 7.92799C8.5675 8.02084 8.63905 8.1535 8.63905 8.31968C8.63905 8.49851 8.5666 8.63679 8.43603 8.73202C8.30356 8.82863 8.10717 8.88368 7.85696 8.88368Z'
										fill='#C5C5C5'
										stroke='#C5C5C5'
										strokeWidth='0.1'
									/>
								</g>
							</svg>

							<p>Inicio</p>
						</Link>
					</li>
					<li>
						<Link to='/'>
							<svg
								width='14'
								height='14'
								viewBox='0 0 14 14'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<mask
									id='mask0_2447_787'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='14'
									height='14'
								>
									<rect width='14' height='14' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_2447_787)'>
									<path
										d='M7.7956 13.6C7.58187 13.6 7.37537 13.5587 7.1761 13.4761C6.97683 13.3935 6.7946 13.2696 6.6294 13.1044L1.4669 7.9706C1.30123 7.8054 1.182 7.62083 1.1092 7.4169C1.0364 7.2125 1 7.00833 1 6.8044V2.6044C1 2.14707 1.15307 1.76533 1.4592 1.4592C1.76533 1.15307 2.14707 1 2.6044 1H6.8044C7.01813 1 7.2223 1.0413 7.4169 1.1239C7.61103 1.2065 7.78603 1.32573 7.9419 1.4816L13.1478 6.6434C13.4689 6.96447 13.6268 7.3413 13.6217 7.7739C13.617 8.2065 13.4493 8.58333 13.1184 8.9044L8.9184 13.1044C8.763 13.2598 8.59057 13.3811 8.4011 13.4684C8.21163 13.5561 8.0098 13.6 7.7956 13.6ZM7.8103 11.9956L12.0103 7.7956L6.8044 2.6044H2.6044V6.8044L7.8103 11.9956ZM4.0772 5.1566C4.37867 5.1566 4.63627 5.0495 4.85 4.8353C5.06373 4.62157 5.1706 4.36397 5.1706 4.0625C5.1706 3.76103 5.06373 3.50343 4.85 3.2897C4.63627 3.0755 4.37867 2.9684 4.0772 2.9684C3.77573 2.9684 3.51813 3.0755 3.3044 3.2897C3.0902 3.50343 2.9831 3.76103 2.9831 4.0625C2.9831 4.36397 3.0902 4.62157 3.3044 4.8353C3.51813 5.0495 3.77573 5.1566 4.0772 5.1566Z'
										fill='#C5C5C5'
									/>
								</g>
							</svg>

							<p>Optimización</p>
						</Link>
					</li>
					<li>
						<Link to='/'>
							<svg
								width='15'
								height='15'
								viewBox='0 0 15 15'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<mask
									id='mask0_2447_6587'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='15'
									height='15'
								>
									<rect width='15' height='15' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_2447_6587)'>
									<path
										d='M1.75 13.2499V11.8594L3.0625 10.5469V13.2499H1.75ZM4.29663 13.2499V9.35925L5.60913 8.04675V13.2499H4.29663ZM6.84363 13.2499V8.04675L8.15613 9.375V13.2499H6.84363ZM9.406 13.2499V9.375L10.7185 8.0625V13.2499H9.406ZM11.953 13.2499V6.8595L13.2655 5.547V13.2499H11.953ZM1.75 9.90637V8.0625L6.25 3.57825L8.74975 6.078L13.2655 1.54688V3.39075L8.74975 7.92188L6.25 5.42175L1.75 9.90637Z'
										fill='#C5C5C5'
									/>
								</g>
							</svg>

							<p>Reportes</p>
						</Link>
					</li>
					<li>
						<Link to='/BusquedadePromociones'>
							<svg
								width='15'
								height='16'
								viewBox='0 0 15 16'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path
									d='M13.6837 12.4453L9.72822 8.55647C10.4624 7.59534 10.7957 6.39634 10.6604 5.20307C10.5251 4.00979 9.93138 2.91174 8.99981 2.13201C8.06823 1.35228 6.86871 0.94936 5.64494 1.0051C4.42117 1.06084 3.26495 1.57106 2.41119 2.43211C1.73709 3.09416 1.2782 3.93706 1.09242 4.85444C0.906637 5.77183 1.00229 6.72259 1.3673 7.58675C1.73231 8.45092 2.35033 9.18976 3.14337 9.71005C3.93641 10.2303 4.86894 10.5088 5.82328 10.5102C6.74251 10.5063 7.64222 10.25 8.42025 9.7702L12.4137 13.6838C12.4935 13.7777 12.5924 13.8541 12.7041 13.9084C12.8157 13.9627 12.9377 13.9936 13.0622 13.9991C13.1868 14.0046 13.3111 13.9846 13.4273 13.9405C13.5435 13.8963 13.6491 13.8288 13.7372 13.7424C13.8253 13.6561 13.8942 13.5526 13.9392 13.4387C13.9843 13.3249 14.0047 13.203 13.9991 13.081C13.9935 12.9589 13.9619 12.8394 13.9066 12.73C13.8512 12.6205 13.7731 12.5236 13.6774 12.4453H13.6837ZM3.67492 7.8753C3.39494 7.60175 3.17279 7.27675 3.02122 6.91891C2.86964 6.56107 2.79162 6.17743 2.79162 5.78998C2.79162 5.40253 2.86964 5.01889 3.02122 4.66105C3.17279 4.30321 3.39494 3.9782 3.67492 3.70466C3.95942 3.42972 4.29644 3.21244 4.6667 3.06528C5.03697 2.91811 5.43321 2.84394 5.83275 2.847C6.63367 2.8507 7.40177 3.15935 7.97479 3.70776C8.5361 4.26865 8.85053 5.02293 8.85053 5.80856C8.85053 6.59418 8.5361 7.34846 7.97479 7.90936C7.39619 8.45645 6.62173 8.75934 5.81776 8.75297C5.01378 8.7466 4.24443 8.43148 3.67492 7.8753Z'
									fill='#C5C5C5'
								/>
							</svg>

							<p>Busqueda de Promociones</p>
						</Link>
					</li>
					<li>
						<Link to='/'>
							<svg
								width='15'
								height='15'
								viewBox='0 0 15 15'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<mask
									id='mask0_2447_286130'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='15'
									height='15'
								>
									<rect width='15' height='15' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_2447_286130)'>
									<path
										d='M8.06238 7.203L9.76562 8.8905C9.89062 9.0155 9.95312 9.16925 9.95312 9.35175C9.95312 9.534 9.89062 9.68762 9.76562 9.81262C9.63013 9.94788 9.47388 10.0155 9.29688 10.0155C9.11963 10.0155 8.9685 9.94788 8.8435 9.81262L6.92163 7.93762C6.85913 7.87512 6.81488 7.80737 6.78888 7.73438C6.76288 7.66138 6.74988 7.578 6.74988 7.48425V4.82812C6.74988 4.65112 6.81238 4.4975 6.93738 4.36725C7.06238 4.237 7.21338 4.17188 7.39038 4.17188C7.57788 4.17188 7.73675 4.237 7.867 4.36725C7.99725 4.4975 8.06238 4.65112 8.06238 4.82812V7.203ZM7.62475 13.4531C6.1665 13.4531 4.89838 13.0078 3.82037 12.117C2.74213 11.2265 2.06762 10.0781 1.79688 8.67188C1.74463 8.47388 1.77325 8.29425 1.88275 8.133C1.992 7.9715 2.14563 7.88025 2.34363 7.85925C2.51038 7.849 2.66138 7.89075 2.79663 7.9845C2.93213 8.07825 3.02075 8.20325 3.0625 8.3595C3.302 9.45325 3.83588 10.3569 4.66412 11.0704C5.49213 11.7839 6.47388 12.1406 7.60938 12.1406C8.90088 12.1406 9.99975 11.6823 10.906 10.7655C11.8123 9.849 12.2654 8.74487 12.2654 7.45312C12.2654 6.17188 11.8123 5.086 10.906 4.1955C9.99975 3.30475 8.906 2.85938 7.62475 2.85938C6.8645 2.85938 6.15363 3.0365 5.49213 3.39075C4.83063 3.74475 4.28113 4.22388 3.84363 4.82812H4.95288C5.13013 4.82812 5.28387 4.89062 5.41412 5.01562C5.54413 5.14062 5.60913 5.29688 5.60913 5.48438C5.60913 5.66138 5.54413 5.815 5.41412 5.94525C5.28387 6.0755 5.13013 6.14062 4.95288 6.14062H2.3125C2.125 6.14062 1.96875 6.07812 1.84375 5.95312C1.71875 5.82812 1.65625 5.67188 1.65625 5.48438V2.84363C1.65625 2.66663 1.72138 2.51562 1.85163 2.39062C1.98163 2.26562 2.13525 2.20312 2.3125 2.20312C2.4895 2.20312 2.64313 2.26562 2.77338 2.39062C2.90363 2.51562 2.96875 2.66663 2.96875 2.84363V3.81262C3.52075 3.08337 4.20563 2.5235 5.02338 2.133C5.84113 1.74225 6.70825 1.54688 7.62475 1.54688C8.44775 1.54688 9.22125 1.70312 9.94525 2.01562C10.6693 2.32812 11.2994 2.75 11.8356 3.28125C12.3721 3.8125 12.7966 4.44012 13.1091 5.16412C13.4216 5.88812 13.5779 6.6615 13.5779 7.48425C13.5779 8.30725 13.4216 9.08075 13.1091 9.80475C12.7966 10.5288 12.3721 11.1615 11.8356 11.703C11.2994 12.2448 10.6693 12.6719 9.94525 12.9844C9.22125 13.2969 8.44775 13.4531 7.62475 13.4531Z'
										fill='#C5C5C5'
									/>
								</g>
							</svg>

							<p>Historial de Promociones</p>
						</Link>
					</li>
					<li className='breaker_system'>
						<p>Mantenedores</p>
						<svg
							width='10'
							height='6'
							viewBox='0 0 10 6'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								d='M9 1L5 5L1 0.999999'
								stroke='#87D7D6'
								strokeLinecap='round'
								strokeLinejoin='round'
							/>
						</svg>
					</li>
					<li>
						<Link to='/'>
							<svg
								width='15'
								height='15'
								viewBox='0 0 15 15'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<mask
									id='mask0_2447_286204'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='15'
									height='15'
								>
									<rect width='15' height='15' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_2447_286204)'>
									<path
										d='M0.6405 13.125C0.453 13.125 0.299375 13.0651 0.179625 12.9454C0.059875 12.8256 0 12.672 0 12.4845V11.25C0 10.8332 0.099 10.4635 0.297 10.1407C0.49475 9.81775 0.77075 9.57287 1.125 9.40612C1.875 9.06237 2.58337 8.80725 3.25012 8.64075C3.91663 8.474 4.60413 8.39062 5.31262 8.39062C6.01038 8.39062 6.69263 8.474 7.35938 8.64075C8.02612 8.80725 8.7345 9.06237 9.4845 9.40612C9.8385 9.57287 10.1171 9.81775 10.3204 10.1407C10.5234 10.4635 10.6249 10.8332 10.6249 11.25V12.4999C10.6249 12.6771 10.5624 12.8256 10.4374 12.9454C10.3124 13.0651 10.1614 13.125 9.98438 13.125H0.6405ZM11.3126 13.125C11.4166 13.1042 11.5104 13.0391 11.5939 12.9296C11.6771 12.8204 11.7188 12.6667 11.7188 12.4687V11.172C11.7188 10.5885 11.5703 10.0546 11.2733 9.57037C10.9765 9.08587 10.5573 8.68225 10.0155 8.3595C10.7552 8.44275 11.4506 8.57025 12.1016 8.742C12.7526 8.914 13.3073 9.125 13.7655 9.375C14.1615 9.59375 14.4689 9.85937 14.6876 10.1719C14.9064 10.4844 15.0157 10.8177 15.0157 11.172V12.4999C15.0157 12.6771 14.9532 12.8256 14.8282 12.9454C14.7032 13.0651 14.5521 13.125 14.3749 13.125H11.3126ZM5.31262 7.40625C4.53137 7.40625 3.88812 7.15362 3.38287 6.64837C2.87762 6.14312 2.625 5.50512 2.625 4.73437C2.625 3.96362 2.87762 3.32037 3.38287 2.80462C3.88812 2.28912 4.52612 2.03137 5.29688 2.03137C6.06763 2.03137 6.71088 2.28912 7.22662 2.80462C7.74213 3.32037 7.99988 3.95837 7.99988 4.71862C7.99988 5.49987 7.74213 6.14312 7.22662 6.64837C6.71088 7.15362 6.07288 7.40625 5.31262 7.40625ZM12.0157 4.71862C12.0157 5.49987 11.7605 6.14312 11.25 6.64837C10.7395 7.15362 10.0989 7.40625 9.32812 7.40625C9.18237 7.40625 9.00275 7.39325 8.78925 7.36725C8.5755 7.34125 8.401 7.30212 8.26575 7.24987C8.5365 6.92712 8.73962 6.55212 8.87512 6.12487C9.01038 5.69787 9.078 5.23437 9.078 4.73437C9.078 4.22387 9.01038 3.763 8.87512 3.35175C8.73962 2.94025 8.5365 2.55212 8.26575 2.18737C8.422 2.14587 8.5965 2.1095 8.78925 2.07825C8.98175 2.047 9.16138 2.03137 9.32812 2.03137C10.0989 2.03137 10.7395 2.28912 11.25 2.80462C11.7605 3.32037 12.0157 3.95837 12.0157 4.71862ZM1.3125 11.8125H9.31238V11.25C9.31238 11.1042 9.2785 10.9689 9.21075 10.8439C9.14325 10.7189 9.05212 10.6355 8.93738 10.5937C8.23962 10.2812 7.6095 10.0547 7.047 9.91425C6.4845 9.7735 5.90637 9.70312 5.31262 9.70312C4.70837 9.70312 4.125 9.7735 3.5625 9.91425C3 10.0547 2.36975 10.2812 1.67175 10.5937C1.55725 10.6355 1.46875 10.7189 1.40625 10.8439C1.34375 10.9689 1.3125 11.1042 1.3125 11.25V11.8125ZM5.31262 6.09375C5.69788 6.09375 6.02338 5.9635 6.28912 5.703C6.55463 5.44275 6.68738 5.11462 6.68738 4.71862C6.68738 4.33337 6.55463 4.00787 6.28912 3.74212C6.02338 3.47662 5.69263 3.34387 5.29688 3.34387C4.91138 3.34387 4.5885 3.47662 4.32825 3.74212C4.06775 4.00787 3.9375 4.33862 3.9375 4.73437C3.9375 5.11987 4.06775 5.44275 4.32825 5.703C4.5885 5.9635 4.91663 6.09375 5.31262 6.09375Z'
										fill='#C5C5C5'
									/>
								</g>
							</svg>

							<p>Gestión de Usuarios</p>
						</Link>
					</li>
					<li>
						<Link to='/'>
							<svg
								width='15'
								height='15'
								viewBox='0 0 15 15'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<mask
									id='mask0_2447_286278'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='15'
									height='15'
								>
									<rect width='15' height='15' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_2447_286278)'>
									<path
										d='M4.78125 10.8281C4.96875 10.8281 5.125 10.763 5.25 10.6327C5.375 10.5025 5.4375 10.3436 5.4375 10.1561V6.84375C5.4375 6.65625 5.37238 6.5 5.24213 6.375C5.11188 6.25 4.95825 6.1875 4.78125 6.1875C4.60425 6.1875 4.45062 6.25 4.32037 6.375C4.19012 6.5 4.125 6.65625 4.125 6.84375V10.1561C4.125 10.3436 4.19012 10.5025 4.32037 10.6327C4.45062 10.763 4.60425 10.8281 4.78125 10.8281ZM7.51575 10.8281C7.69275 10.8281 7.84637 10.763 7.97662 10.6327C8.10687 10.5025 8.172 10.3436 8.172 10.1561V4.82812C8.172 4.65112 8.10687 4.4975 7.97662 4.36725C7.84637 4.237 7.69275 4.17188 7.51575 4.17188C7.32825 4.17188 7.172 4.237 7.047 4.36725C6.922 4.4975 6.8595 4.65112 6.8595 4.82812V10.1561C6.8595 10.3436 6.922 10.5025 7.047 10.6327C7.172 10.763 7.32825 10.8281 7.51575 10.8281ZM10.2188 10.8281C10.4062 10.8281 10.5625 10.763 10.6875 10.6327C10.8125 10.5025 10.875 10.3436 10.875 10.1561V8.8125C10.875 8.625 10.8099 8.46875 10.6796 8.34375C10.5494 8.21875 10.3958 8.15625 10.2188 8.15625C10.0417 8.15625 9.88813 8.21875 9.75788 8.34375C9.62762 8.46875 9.5625 8.625 9.5625 8.8125V10.1561C9.5625 10.3436 9.62762 10.5025 9.75788 10.6327C9.88813 10.763 10.0417 10.8281 10.2188 10.8281ZM2.85938 13.4531C2.50512 13.4531 2.19787 13.3229 1.93762 13.0624C1.67712 12.8021 1.54688 12.4949 1.54688 12.1406V2.85938C1.54688 2.50512 1.67712 2.19787 1.93762 1.93762C2.19787 1.67712 2.50512 1.54688 2.85938 1.54688H8.31262C8.50012 1.54688 8.65637 1.60937 8.78137 1.73438C8.90637 1.85938 8.96887 2.01562 8.96887 2.20312C8.96887 2.38012 8.90637 2.53375 8.78137 2.664C8.65637 2.79425 8.50012 2.85938 8.31262 2.85938H2.85938V12.1406H12.1406V6.68738C12.1406 6.49988 12.2057 6.34363 12.336 6.21863C12.4663 6.09363 12.6251 6.03113 12.8126 6.03113C12.9896 6.03113 13.1406 6.09363 13.2656 6.21863C13.3906 6.34363 13.4531 6.49988 13.4531 6.68738V12.1406C13.4531 12.4949 13.3229 12.8021 13.0624 13.0624C12.8021 13.3229 12.4949 13.4531 12.1406 13.4531H2.85938ZM11.4844 5.5155C11.2969 5.5155 11.1406 5.4505 11.0156 5.3205C10.8906 5.19025 10.8281 5.03137 10.8281 4.84387V4.18762H10.1561C9.96863 4.18762 9.80975 4.1225 9.6795 3.99225C9.5495 3.862 9.4845 3.70837 9.4845 3.53137C9.4845 3.34387 9.5495 3.18762 9.6795 3.06262C9.80975 2.93762 9.96863 2.87512 10.1561 2.87512H10.8281V2.18738C10.8281 2.01038 10.8906 1.85938 11.0156 1.73438C11.1406 1.60937 11.2969 1.54688 11.4844 1.54688C11.6614 1.54688 11.815 1.60937 11.9452 1.73438C12.0755 1.85938 12.1406 2.01038 12.1406 2.18738V2.87512H12.8126C12.9896 2.87512 13.1406 2.94025 13.2656 3.0705C13.3906 3.2005 13.4531 3.35412 13.4531 3.53137C13.4531 3.70837 13.3906 3.862 13.2656 3.99225C13.1406 4.1225 12.9896 4.18762 12.8126 4.18762H12.1406V4.84387C12.1406 5.03137 12.0755 5.19025 11.9452 5.3205C11.815 5.4505 11.6614 5.5155 11.4844 5.5155Z'
										fill='#C5C5C5'
									/>
								</g>
							</svg>

							<p>Planes de Venta</p>
						</Link>
					</li>
					<li>
						<Link to='/'>
							<svg
								width='15'
								height='16'
								viewBox='0 0 15 16'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<g clipPath='url(#clip0_2447_286364)'>
									<mask
										id='mask0_2447_286364'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='15'
										height='15'
									>
										<rect width='15' height='15' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_2447_286364)'>
										<path
											d='M0.109375 2.79675H1.51562V12.1875H0.109375V2.79675ZM4.14062 2.79675H4.81225V12.1875H4.14062V2.79675ZM2.125 2.79675H3.48438V12.1875H2.125V2.79675ZM12.8905 2.79675H14.9219V12.1875H12.8905V2.79675ZM6.17163 2.79675H7.49988V12.1875H6.17163V2.79675ZM10.8749 2.79675H11.5469V12.1875H10.8749V2.79675ZM8.18725 2.79675H10.2029V12.1875H8.18725V2.79675Z'
											fill='#C5C5C5'
										/>
									</g>
								</g>
								<defs>
									<clipPath id='clip0_2447_286364'>
										<rect
											width='15'
											height='15'
											fill='white'
											transform='translate(0 0.5)'
										/>
									</clipPath>
								</defs>
							</svg>

							<p>Productos</p>
						</Link>
					</li>
					{/* <li>
            <Link to="/">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_2447_286497"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="15"
                  height="15"
                >
                  <rect width="15" height="15" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_2447_286497)">
                  <path
                    d="M9.42188 4.2345C9.19263 4.2345 8.98425 4.17712 8.79675 4.06237C8.60925 3.94787 8.5155 3.7865 8.5155 3.57825C8.5155 3.3595 8.60925 3.19537 8.79675 3.08587C8.98425 2.97662 9.19263 2.922 9.42188 2.922H13.3125C13.4895 2.922 13.6431 2.9845 13.7734 3.1095C13.9036 3.2345 13.9688 3.39075 13.9688 3.57825C13.9688 3.75525 13.9036 3.90887 13.7734 4.03912C13.6431 4.16937 13.4895 4.2345 13.3125 4.2345H9.42188ZM9.42188 7.81237C9.23438 7.81237 9.07812 7.74725 8.95312 7.617C8.82812 7.487 8.76562 7.33337 8.76562 7.15612C8.76562 6.96862 8.82812 6.81237 8.95312 6.68737C9.07812 6.56237 9.23438 6.49987 9.42188 6.49987H13.3125C13.4895 6.49987 13.6431 6.565 13.7734 6.69525C13.9036 6.8255 13.9688 6.97912 13.9688 7.15612C13.9688 7.33337 13.9036 7.487 13.7734 7.617C13.6431 7.74725 13.4895 7.81237 13.3125 7.81237H9.42188ZM9.42188 11.3906C9.23438 11.3906 9.07812 11.3281 8.95312 11.2031C8.82812 11.0781 8.76562 10.9219 8.76562 10.7344C8.76562 10.5574 8.82812 10.4037 8.95312 10.2735C9.07812 10.1432 9.23438 10.0781 9.42188 10.0781H13.3125C13.4895 10.0781 13.6431 10.1432 13.7734 10.2735C13.9036 10.4037 13.9688 10.5574 13.9688 10.7344C13.9688 10.9219 13.9036 11.0781 13.7734 11.2031C13.6431 11.3281 13.4895 11.3906 13.3125 11.3906H9.42188ZM4.64062 12.7031C4.51562 12.5781 4.45312 12.4271 4.45312 12.2501C4.45312 12.0729 4.51562 11.9114 4.64062 11.7656L5.04675 11.3595C3.9115 11.3177 2.95838 10.8906 2.18738 10.0781C1.41663 9.26562 1.03125 8.28125 1.03125 7.125C1.03125 5.96875 1.44012 4.97912 2.25787 4.15612C3.07562 3.33337 4.073 2.922 5.25 2.922H6.81262C6.98962 2.922 7.14325 2.9845 7.2735 3.1095C7.40375 3.2345 7.46887 3.39075 7.46887 3.57825C7.46887 3.75525 7.40375 3.90887 7.2735 4.03912C7.14325 4.16937 6.98962 4.2345 6.81262 4.2345H5.25C4.4375 4.2345 3.75 4.51575 3.1875 5.07825C2.625 5.64075 2.34375 6.32825 2.34375 7.14075C2.34375 7.89075 2.599 8.53912 3.1095 9.08587C3.61975 9.63287 4.24988 9.95325 4.99988 10.047L4.64062 9.68737C4.53638 9.56237 4.48688 9.41137 4.49213 9.23437C4.49738 9.05737 4.55725 8.90637 4.67175 8.78137C4.80725 8.66662 4.9635 8.60925 5.1405 8.60925C5.31775 8.60925 5.474 8.66662 5.60925 8.78137L7.07812 10.2814C7.14062 10.3439 7.1875 10.4167 7.21875 10.5C7.25 10.5832 7.26562 10.6614 7.26562 10.7344C7.26562 10.8176 7.25 10.8984 7.21875 10.9766C7.1875 11.0546 7.14062 11.1249 7.07812 11.1874L5.56238 12.7189C5.42712 12.8439 5.2735 12.9064 5.1015 12.9064C4.92975 12.9064 4.77612 12.8386 4.64062 12.7031Z"
                    fill="#C5C5C5"
                  />
                </g>
              </svg>

              <p>Orden de Líneas</p>
            </Link>
          </li> */}
					<li>
						<Link to='/'>
							<svg
								width='15'
								height='15'
								viewBox='0 0 15 15'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<mask
									id='mask0_2447_13720'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='15'
									height='15'
								>
									<rect
										x='15'
										width='15'
										height='15'
										transform='rotate(90 15 0)'
										fill='#D9D9D9'
									/>
								</mask>
								<g mask='url(#mask0_2447_13720)'>
									<path
										d='M1 7.50777C1 7.33301 1.06476 7.18132 1.19427 7.05271C1.32379 6.9241 1.48024 6.8598 1.66364 6.8598H4.36754C4.85322 6.8598 5.24708 6.79044 5.54911 6.65171C5.8514 6.51273 6.159 6.28897 6.47191 5.98041L7.44327 6.90609C7.33552 7.00902 7.21416 7.11183 7.0792 7.21452C6.94425 7.31746 6.81201 7.41521 6.6825 7.50777C6.89827 7.66205 7.09254 7.81115 7.26532 7.95506C7.43809 8.09922 7.58924 8.24326 7.71875 8.38717C8.23681 8.9838 8.80072 9.38752 9.41048 9.59832C10.0202 9.80913 10.773 9.90935 11.6687 9.89898L10.9728 9.23583C10.8433 9.10204 10.7786 8.95035 10.7786 8.78077C10.7786 8.61093 10.8433 8.45912 10.9728 8.32533C11.1023 8.20191 11.2588 8.13773 11.4422 8.13279C11.6256 8.12761 11.782 8.19179 11.9116 8.32533L13.8057 10.1304C13.8705 10.1921 13.9191 10.2616 13.9514 10.3389C13.9838 10.4159 14 10.4956 14 10.5781C14 10.6603 13.9838 10.74 13.9514 10.8173C13.9191 10.8943 13.8705 10.9636 13.8057 11.0253L11.9279 12.8149C11.7984 12.9383 11.6392 13 11.4504 13C11.2615 13 11.1023 12.9383 10.9728 12.8149C10.8324 12.6813 10.7622 12.5296 10.7622 12.3598C10.7622 12.1902 10.8324 12.0437 10.9728 11.9203L11.7173 11.2105C10.6164 11.2208 9.68558 11.0922 8.9248 10.8247C8.16377 10.5573 7.41633 10.038 6.6825 9.26656C6.30483 8.86543 5.9541 8.58008 5.63031 8.41049C5.30652 8.24066 4.8856 8.15575 4.36754 8.15575H1.66364C1.48024 8.15575 1.32379 8.09144 1.19427 7.96284C1.06476 7.83423 1 7.68254 1 7.50777Z'
										fill='#C5C5C5'
									/>
									<path
										d='M1.00012 7.49222C1.00012 7.66699 1.06488 7.81868 1.1944 7.94729C1.32391 8.07589 1.48037 8.1402 1.66376 8.1402H4.36766C4.85334 8.1402 5.2472 8.20956 5.54923 8.34829C5.85152 8.48726 6.15912 8.71103 6.47203 9.01959L7.4434 8.09391C7.33564 7.99098 7.21428 7.88817 7.07933 7.78548C6.94437 7.68254 6.81214 7.58479 6.68262 7.49222C6.8984 7.33794 7.09267 7.18885 7.26544 7.04494C7.43822 6.90078 7.58936 6.75674 7.71888 6.61283C8.23694 6.0162 8.80085 5.61248 9.41061 5.40168C10.0204 5.19087 10.7731 5.09065 11.6688 5.10102L10.973 5.76417C10.8434 5.89796 10.7787 6.04965 10.7787 6.21923C10.7787 6.38906 10.8434 6.54087 10.973 6.67467C11.1025 6.79809 11.2589 6.86227 11.4423 6.86721C11.6257 6.87239 11.7822 6.80821 11.9117 6.67467L13.8059 4.8696C13.8706 4.80788 13.9192 4.7384 13.9516 4.66113C13.9839 4.58412 14.0001 4.50439 14.0001 4.42194C14.0001 4.33974 13.9839 4.26001 13.9516 4.18274C13.9192 4.10573 13.8706 4.03637 13.8059 3.97465L11.928 2.18513C11.7985 2.06171 11.6393 2 11.4505 2C11.2616 2 11.1025 2.06171 10.973 2.18513C10.8326 2.31868 10.7624 2.47037 10.7624 2.6402C10.7624 2.80978 10.8326 2.95629 10.973 3.07971L11.7174 3.78952C10.6165 3.77915 9.6857 3.90776 8.92493 4.17534C8.16389 4.44268 7.41646 4.96204 6.68262 5.73344C6.30496 6.13456 5.95423 6.41992 5.63044 6.5895C5.30665 6.75933 4.88572 6.84425 4.36766 6.84425H1.66376C1.48037 6.84425 1.32391 6.90855 1.1944 7.03716C1.06488 7.16577 1.00012 7.31746 1.00012 7.49222Z'
										fill='#C5C5C5'
									/>
								</g>
							</svg>

							<p>Variables Promocionales</p>
						</Link>
					</li>
				</nav>
			</div>
			<div className='center_area'>
				<div className='logo_wrapper'>
					<img src={logotwo} alt='' />
				</div>
				{!noNeedSearch && (
					<div className='input_wrapper search_navbar'>
						<input
							type='text'
							placeholder='Nombre de Promoción'
							value={SearchInput}
							onFocus={(e) => {
								setShowSearch(false)
							}}
							onChange={(e) => {
								setSearchInput(e.target.value)
							}}
						/>
						<button
							style={{cursor: 'pointer'}}
							onClick={(e) => {
								const Filter = Products.filter((EachProduct) => {
									const Mainp = EachProduct.mainp.toLowerCase()
									const SearchInputLocal = SearchInput.toLowerCase()

									if (Mainp.includes(SearchInputLocal)) {
										return true
									}

									return false
								})

								setShowSearch(true)
								setSearchProducts(Filter)
							}}
						>
							Buscar
						</button>

						{ShowSearch && (
							<SearchResult SearchingProducts={SearchingProducts} />
						)}
					</div>
				)}
			</div>

			<div className='right_side'>
				<div className='notify_wrapper'>
					<svg
						width='20'
						height='20'
						viewBox='0 0 20 20'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<path
							d='M9.99967 2C8.67365 2 7.40186 2.52683 6.46419 3.4645C5.52651 4.40218 4.99968 5.67396 4.99968 6.99999V9.08493L3.70714 10.3775C3.25442 10.8304 3 11.4445 3 12.0849C3 12.7254 3.25443 13.3396 3.70732 13.7925C4.16004 14.2454 4.77419 14.4998 5.41473 14.5H14.5848C15.2253 14.4998 15.8395 14.2454 16.2922 13.7925C16.7451 13.3396 16.9995 12.7254 16.9995 12.0849C16.9995 11.4445 16.7451 10.8303 16.2924 10.3775L14.9998 9.08493V6.99999C14.9998 5.67396 14.473 4.40218 13.5353 3.4645C12.5977 2.52683 11.3259 2 9.99985 2H9.99967ZM14.5845 12.5H5.41441C5.24718 12.4993 5.09668 12.3981 5.03268 12.2434C4.96886 12.0889 5.00391 11.9111 5.12179 11.7925L6.99942 9.91502V6.99998C6.99942 5.9282 7.57125 4.93771 8.49933 4.40182C9.42759 3.86593 10.5712 3.86593 11.4995 4.40182C12.4275 4.93771 12.9994 5.9282 12.9994 6.99998V9.91502L14.8768 11.7925H14.877C14.9949 11.911 15.0299 12.0889 14.9661 12.2434C14.9021 12.3981 14.7516 12.4993 14.5844 12.5H14.5845Z'
							fill='#87D7D6'
						/>
						<path
							d='M7.7998 17C7.7998 16.4477 8.24753 16 8.79982 16H10.7999C11.3522 16 11.7999 16.4477 11.7999 17C11.7999 17.5523 11.3522 18 10.7999 18H8.79982C8.24753 18 7.7998 17.5523 7.7998 17Z'
							fill='#87D7D6'
						/>
					</svg>
					<ul className='notify_area_list'>
						<li className='top_area'>
							<h1>Notificaciones</h1>
							<img
								src={threeDots}
								alt=''
								style={{cursor: 'pointer'}}
								onClick={(e) => {
									setdropdownExe(!dropdownExe)
								}}
							/>
							{dropdownExe && (
								<ul>
									<li>
										<a href='#'>Marcar todas camo leidas</a>
									</li>
									<li>
										<a href='#'>Abrir Notificaciones</a>
									</li>
								</ul>
							)}
						</li>
						<li className='heading'>Nuevas Notificaciones</li>

						<li className='notification'>
							<img src={tipo} alt='' />
							<div className='presentation'>
								<p>
									Hay cambios en&nbsp;
									<span>Promoción</span>
								</p>
								<p>hace 2hrs</p>
							</div>
						</li>
						<li className='notification blue'>
							<img src={movio} alt='' />
							<div className='presentation'>
								<p>
									<span>Usuario</span>&nbsp;movió&nbsp;
									<span>Promoción</span>
								</p>
								<p>hace 2hrs</p>
							</div>
						</li>
						<li className='notification green'>
							<img src={comment} alt='' />
							<div className='presentation'>
								<p>
									<span>Usuario</span>&nbsp;comentó&nbsp;
									<span>Promoción</span>
								</p>
								<p>hace 2hrs</p>
							</div>
						</li>
						<li className='heading' style={{marginTop: 13}}>
							Anteriores
						</li>
						<li className='notification blackCol'>
							<img src={Tipoblack} alt='' />
							<div className='presentation'>
								<p>
									<span>Usuario</span>&nbsp;movió&nbsp;
									<span>Promoción</span>
								</p>
								<p>hace 2hrs</p>
							</div>
						</li>
					</ul>
				</div>
				<div className='avatar avatar_wrapper'>
					<div>
						<img src={Avatar} alt='' />
						<p>Pedro P.</p>
						<svg
							width='10'
							height='6'
							style={{marginLeft: 10}}
							viewBox='0 0 10 6'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								d='M9.35355 1.10355C9.54882 0.908291 9.54882 0.591709 9.35355 0.396447C9.15829 0.201185 8.84171 0.201185 8.64645 0.396447L9.35355 1.10355ZM5 4.75L4.64645 5.10355C4.84171 5.29882 5.15829 5.29882 5.35355 5.10355L5 4.75ZM1.35355 0.396446C1.15829 0.201184 0.84171 0.201184 0.646448 0.396446C0.451185 0.591708 0.451185 0.908291 0.646448 1.10355L1.35355 0.396446ZM8.64645 0.396447L4.64645 4.39645L5.35355 5.10355L9.35355 1.10355L8.64645 0.396447ZM5.35355 4.39645L1.35355 0.396446L0.646448 1.10355L4.64645 5.10355L5.35355 4.39645Z'
								fill='#E8E8E8'
							/>
						</svg>
					</div>

					<ul className='menu_dropdown'>
						<li>
							<a href='#'>
								<svg
									width='15'
									height='15'
									viewBox='0 0 15 15'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_2470_3886'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='15'
										height='15'
									>
										<rect width='15' height='15' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_2470_3886)'>
										<path
											d='M7.49988 13.75C6.63538 13.75 5.82288 13.5859 5.06238 13.2576C4.30188 12.9296 3.64038 12.4844 3.07788 11.9219C2.51538 11.3594 2.07013 10.6979 1.74213 9.93738C1.41388 9.17688 1.24976 8.36438 1.24976 7.49988C1.24976 6.63538 1.41388 5.82288 1.74213 5.06238C2.07013 4.30188 2.51538 3.64038 3.07788 3.07788C3.64038 2.51538 4.30188 2.07013 5.06238 1.74213C5.82288 1.41388 6.63538 1.24976 7.49988 1.24976C8.36438 1.24976 9.17688 1.41388 9.93738 1.74213C10.6979 2.07013 11.3594 2.51538 11.9219 3.07788C12.4844 3.64038 12.9296 4.30188 13.2576 5.06238C13.5859 5.82288 13.75 6.63538 13.75 7.49988C13.75 8.36438 13.5859 9.17688 13.2576 9.93738C12.9296 10.6979 12.4844 11.3594 11.9219 11.9219C11.3594 12.4844 10.6979 12.9296 9.93738 13.2576C9.17688 13.5859 8.36438 13.75 7.49988 13.75ZM5.64063 12.3906L6.54663 10.2498C6.13013 10.104 5.76813 9.87751 5.46063 9.57026C5.15338 9.26301 4.91651 8.89576 4.75001 8.46851L2.60913 9.32801C2.91138 10.0468 3.32288 10.6691 3.84363 11.1951C4.36438 11.7211 4.96338 12.1196 5.64063 12.3906ZM4.73426 6.54663C4.91126 6.10913 5.15338 5.73676 5.46063 5.42951C5.76813 5.12226 6.12501 4.89576 6.53126 4.75001L5.67176 2.60913C4.92176 2.91138 4.28376 3.32813 3.75776 3.85938C3.23176 4.39063 2.84888 4.99476 2.60913 5.67176L4.73426 6.54663ZM7.49988 9.37488C8.02063 9.37488 8.46338 9.19263 8.82813 8.82813C9.19263 8.46338 9.37488 8.02063 9.37488 7.49988C9.37488 6.97913 9.19263 6.53638 8.82813 6.17163C8.46338 5.80713 8.02063 5.62488 7.49988 5.62488C6.97913 5.62488 6.53638 5.80713 6.17163 6.17163C5.80713 6.53638 5.62488 6.97913 5.62488 7.49988C5.62488 8.02063 5.80713 8.46338 6.17163 8.82813C6.53638 9.19263 6.97913 9.37488 7.49988 9.37488ZM9.35913 12.3906C10.0571 12.1094 10.6665 11.7083 11.1873 11.1873C11.7083 10.6665 12.1094 10.0571 12.3906 9.35913L10.2498 8.46851C10.0935 8.90601 9.85913 9.27588 9.54663 9.57813C9.23413 9.88013 8.87476 10.104 8.46851 10.2498L9.35913 12.3906ZM10.2498 6.51551L12.3906 5.64063C12.1094 4.94263 11.7083 4.33326 11.1873 3.81251C10.6665 3.29151 10.0571 2.89038 9.35913 2.60913L8.48426 4.76538C8.89051 4.90088 9.24463 5.12226 9.54663 5.42951C9.84888 5.73676 10.0833 6.09876 10.2498 6.51551Z'
											fill='#C5C5C5'
										/>
									</g>
								</svg>

								<p>Ayuda y Soporte Técnico</p>
							</a>
						</li>
						<li
							onClick={(e) => {
								navigate('/ConfiguraciondelPerfil')
							}}
						>
							<a href='#'>
								<svg
									width='15'
									height='16'
									viewBox='0 0 15 16'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<g clipPath='url(#clip0_2470_74)'>
										<mask
											id='mask0_2470_74'
											maskUnits='userSpaceOnUse'
											x='0'
											y='0'
											width='15'
											height='15'
										>
											<rect width='15' height='15' fill='#D9D9D9' />
										</mask>
										<g mask='url(#mask0_2470_74)'>
											<path
												d='M6.25025 7.45325C5.56275 7.45325 4.99237 7.22412 4.53912 6.76587C4.08612 6.30737 3.85962 5.73438 3.85962 5.04688C3.85962 4.35938 4.08612 3.78912 4.53912 3.33612C4.99237 2.88287 5.56275 2.65625 6.25025 2.65625C6.93775 2.65625 7.508 2.88287 7.961 3.33612C8.41425 3.78912 8.64087 4.35938 8.64087 5.04688C8.64087 5.73438 8.41425 6.30737 7.961 6.76587C7.508 7.22412 6.93775 7.45325 6.25025 7.45325ZM1.76563 12.4531C1.61988 12.4531 1.4975 12.4036 1.3985 12.3046C1.2995 12.2059 1.25 12.0835 1.25 11.9375V10.8909C1.25 10.5366 1.34112 10.2111 1.52337 9.91437C1.70587 9.61737 1.96375 9.39075 2.297 9.2345C2.974 8.922 3.6355 8.68762 4.2815 8.53137C4.92725 8.37512 5.5835 8.297 6.25025 8.297H6.62525C6.55225 8.46375 6.4975 8.62787 6.461 8.78937C6.4245 8.95062 6.39062 9.13025 6.35938 9.32825H6.25025C5.60425 9.32825 4.98962 9.40375 4.40637 9.55475C3.82312 9.70575 3.26587 9.9115 2.73462 10.172C2.58862 10.245 2.47925 10.3491 2.4065 10.4844C2.3335 10.6199 2.297 10.7554 2.297 10.8909V11.4219H6.40625C6.4585 11.6199 6.52625 11.8049 6.6095 11.9769C6.69275 12.1486 6.79175 12.3074 6.9065 12.4531H1.76563ZM6.25025 6.40625C6.6355 6.40625 6.95837 6.27612 7.21887 6.01587C7.47937 5.75537 7.60962 5.43237 7.60962 5.04688C7.60962 4.66162 7.47937 4.34137 7.21887 4.08612C6.95837 3.83087 6.6355 3.70325 6.25025 3.70325C5.86475 3.70325 5.54175 3.83087 5.28125 4.08612C5.021 4.34137 4.89087 4.66162 4.89087 5.04688C4.89087 5.43237 5.021 5.75537 5.28125 6.01587C5.54175 6.27612 5.86475 6.40625 6.25025 6.40625ZM10.7656 11.2344C11.1094 11.2344 11.4036 11.112 11.6484 10.8673C11.8934 10.6225 12.0159 10.3282 12.0159 9.9845C12.0159 9.64075 11.8934 9.3465 11.6484 9.10175C11.4036 8.857 11.1094 8.73462 10.7656 8.73462C10.4219 8.73462 10.1276 8.857 9.88288 9.10175C9.63813 9.3465 9.51575 9.64075 9.51575 9.9845C9.51575 10.3282 9.63813 10.6225 9.88288 10.8673C10.1276 11.112 10.4219 11.2344 10.7656 11.2344ZM10.1094 12.125C9.95312 12.073 9.79688 12.0054 9.64062 11.9221C9.48438 11.8386 9.34375 11.7396 9.21875 11.6251L8.53137 11.7969C8.47937 11.8179 8.42462 11.8179 8.36713 11.7969C8.30988 11.7761 8.26562 11.7345 8.23438 11.672L7.98462 11.2344C7.94287 11.1824 7.92987 11.1277 7.94562 11.0705C7.96112 11.0133 7.98975 10.9585 8.0315 10.9062L8.60938 10.3906C8.58862 10.2761 8.57825 10.1434 8.57825 9.99237C8.57825 9.84137 8.58862 9.7085 8.60938 9.59375L8.0315 9.06275C7.98975 9.021 7.96112 8.9715 7.94562 8.91425C7.92987 8.857 7.94287 8.80225 7.98462 8.75L8.23438 8.297C8.26562 8.245 8.30988 8.2085 8.36713 8.1875C8.42462 8.16675 8.47937 8.16675 8.53137 8.1875L9.21875 8.35962C9.34375 8.24487 9.48438 8.14587 9.64062 8.06262C9.79688 7.97937 9.95312 7.91162 10.1094 7.85938L10.25 7.07825C10.2605 7.00525 10.2891 6.95062 10.3359 6.91437C10.3829 6.87787 10.4376 6.85962 10.5001 6.85962H11.0469C11.1094 6.85962 11.1641 6.87787 11.2111 6.91437C11.2579 6.95062 11.2865 7.00525 11.297 7.07825L11.4219 7.85938C11.5886 7.91162 11.7501 7.97937 11.9064 8.06262C12.0626 8.14587 12.2032 8.24487 12.3282 8.35962L13.0002 8.1875C13.0627 8.15625 13.1226 8.15363 13.1799 8.17963C13.2371 8.20587 13.2761 8.245 13.2969 8.297L13.5627 8.76575C13.594 8.8075 13.6044 8.85962 13.5939 8.92212C13.5834 8.98462 13.5574 9.03662 13.5159 9.07812L12.9376 9.6095C12.9584 9.71375 12.9688 9.844 12.9688 10.0002C12.9688 10.1565 12.9584 10.2866 12.9376 10.3906L13.5001 10.9062C13.5521 10.9585 13.5834 11.0133 13.5939 11.0705C13.6044 11.1277 13.594 11.1824 13.5627 11.2344L13.2969 11.672C13.2761 11.7345 13.2371 11.7761 13.1799 11.7969C13.1226 11.8179 13.0627 11.8179 13.0002 11.7969L12.3282 11.6251C12.2032 11.7396 12.0626 11.8386 11.9064 11.9221C11.7501 12.0054 11.5886 12.073 11.4219 12.125L11.297 12.9065C11.2865 12.969 11.2579 13.021 11.2111 13.0625C11.1641 13.1042 11.1094 13.1251 11.0469 13.1251H10.5001C10.4376 13.1251 10.3829 13.1042 10.3359 13.0625C10.2891 13.021 10.2605 12.969 10.25 12.9065L10.1094 12.125Z'
												fill='#C5C5C5'
											/>
										</g>
									</g>
									<defs>
										<clipPath id='clip0_2470_74'>
											<rect
												width='15'
												height='15'
												fill='white'
												transform='translate(0 0.5)'
											/>
										</clipPath>
									</defs>
								</svg>

								<p>Configuración de Perfil</p>
							</a>
						</li>
						<li>
							<a href='#'>
								<svg
									width='15'
									height='15'
									viewBox='0 0 15 15'
									fill='none'
									xmlns='http://www.w3.org/2000/svg'
								>
									<mask
										id='mask0_2470_3966'
										maskUnits='userSpaceOnUse'
										x='0'
										y='0'
										width='15'
										height='15'
									>
										<rect width='15' height='15' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_2470_3966)'>
										<path
											d='M9.90637 9.98438C9.81262 9.88013 9.76575 9.75513 9.76575 9.60938C9.76575 9.46362 9.81262 9.33862 9.90637 9.23438L11.1251 8.01562H6.297C6.151 8.01562 6.0285 7.96613 5.9295 7.86713C5.83075 7.76813 5.78137 7.64575 5.78137 7.5C5.78137 7.35425 5.83075 7.23187 5.9295 7.13287C6.0285 7.03387 6.151 6.98438 6.297 6.98438H11.1094L9.87488 5.74988C9.78113 5.65613 9.73425 5.53638 9.73425 5.39062C9.73425 5.24487 9.78638 5.11987 9.89062 5.01562C9.98438 4.91138 10.1041 4.85925 10.2499 4.85925C10.3959 4.85925 10.5209 4.91138 10.6249 5.01562L12.7657 7.14075C12.8177 7.20325 12.8541 7.26312 12.8749 7.32037C12.8959 7.37762 12.9064 7.44275 12.9064 7.51575C12.9064 7.57825 12.8959 7.64075 12.8749 7.70325C12.8541 7.76575 12.8177 7.823 12.7657 7.875L10.6406 10.0001C10.5364 10.1041 10.414 10.1535 10.2735 10.1483C10.1327 10.1433 10.0104 10.0886 9.90637 9.98438ZM2.922 13.125C2.64075 13.125 2.39588 13.0209 2.18738 12.8126C1.97913 12.6041 1.875 12.3593 1.875 12.078V2.922C1.875 2.64075 1.97913 2.39588 2.18738 2.18738C2.39588 1.97913 2.64075 1.875 2.922 1.875H6.89062C7.03638 1.875 7.15875 1.9245 7.25775 2.0235C7.35675 2.1225 7.40625 2.24488 7.40625 2.39062C7.40625 2.54688 7.35675 2.6745 7.25775 2.7735C7.15875 2.8725 7.03638 2.922 6.89062 2.922H2.922V12.078H6.89062C7.03638 12.078 7.15875 12.1301 7.25775 12.2344C7.35675 12.3386 7.40625 12.4636 7.40625 12.6094C7.40625 12.7551 7.35675 12.8775 7.25775 12.9765C7.15875 13.0755 7.03638 13.125 6.89062 13.125H2.922Z'
											fill='#C5C5C5'
										/>
									</g>
								</svg>

								<p>Cerrar Sesión</p>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	)
}
